import * as types from '../constants/idpAdminActions';
import {getCustomizationApi, saveCustomizationApi} from "../api/api";
import {ANY_ORIGIN, CANCEL_SAVE_CUSTOMIZATION} from "../constants/postMessages";

export function saveCustomization(customizationData) {
  let formData = new FormData();
  if (customizationData.logo_image) {
    formData.append("logo_image", customizationData.logo_image,
        customizationData.logo_image.name);
  }
  if (customizationData.backgroundColor) {
    formData.append("background_color", customizationData.backgroundColor);
  }
  if (customizationData.sessionTimeout) {
    formData.append("sessionTimeout", customizationData.sessionTimeout.value)
  }
  return (dispatch) => {
    dispatch(saveCustomizationStart());
    return saveCustomizationApi(formData)
    .then(response => {
      dispatch(saveCustomizationSuccess(response));
    })
    .catch((error, response) => {
      dispatch(
          saveCustomizationFail(JSON.parse(error.request.response).reason));
    });
  }
}

export const saveCustomizationStart = () => ({
  type: types.SAVE_CUSTOMIZATION_START
});

export const saveCustomizationSuccess = (response) => ({
  type: types.SAVE_CUSTOMIZATION_SUCCESS,
  response
});

export const saveCustomizationFail = (errorMsg) => ({
  type: types.SAVE_CUSTOMIZATION_FAIL,
  errorMsg,
});

export function getCustomization() {
  return (dispatch) => {
    if (sessionStorage.getItem("authSessionToken")) {
      dispatch(getCustomizationStart());
      return getCustomizationApi()
      .then(response => {
        dispatch(getCustomizationSuccess(response));
      })
      .catch((error) => {
        dispatch(getCustomizationFail(error.message));
      });
    }
  }
}

export const getCustomizationStart = () => ({
  type: types.GET_CUSTOMIZATION_START
});

export const getCustomizationSuccess = (response) => ({
  type: types.GET_CUSTOMIZATION_SUCCESS,
  response
});

export const getCustomizationFail = (errorMsg) => ({
  type: types.GET_CUSTOMIZATION_FAIL,
  errorMsg,
});

export const clearMessages = () => ({
  type: types.CLEAR_MESSAGES,
});

export const setErrorMessage = (errorMsg) => ({
  type: types.SET_ERROR_MESSAGE,
  errorMsg
});

export function cancelSaveCustomization() {
  window.parent.postMessage(CANCEL_SAVE_CUSTOMIZATION, ANY_ORIGIN);
}


// WEBPACK FOOTER //
// ./src/actions/customization.js